import { Mail, Phone, MapPin } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-kala-footer border-t-2 border-transparent bg-clip-padding" style={{
      borderImage: 'linear-gradient(90deg, #2FA8FF, #37E7D9) 1'
    }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <img 
              src="/kalarava-logo.png" 
              alt="KALARAVA Logo" 
              className="h-12 w-auto object-contain"
              style={{
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
              }}
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
            <div>
              <h3 className="text-2xl font-bold bg-gradient-to-r from-kala-blue to-kala-cyan bg-clip-text text-transparent mb-2">
                KALARAVA 2025
              </h3>
              <p className="text-kala-secondary text-sm">
                KLE Society's College of BBA and BCA - 2nd Year Fest
              </p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-3">
            <h4 className="font-semibold text-kala-primary mb-3">Contact</h4>
            <div className="flex items-start gap-2 text-kala-secondary text-sm">
              <Phone size={16} className="mt-0.5 flex-shrink-0" />
              <div className="flex flex-col gap-1">
                <span>7204349740</span>
                <span>9980536788</span>
                <span>7829435777</span>
              </div>
            </div>
            <div className="flex items-start gap-2 text-kala-secondary text-sm">
              <MapPin size={16} className="mt-0.5 flex-shrink-0" />
              <span>1st floor, C.S Angadi Campus Building, Near Byali Kata, Gokak-591307</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-2">
            <h4 className="font-semibold text-kala-primary mb-3">Quick Links</h4>
            <a href="/" className="block text-kala-secondary text-sm hover:text-kala-blue transition-colors">
              Home
            </a>
            <a href="/events" className="block text-kala-secondary text-sm hover:text-kala-blue transition-colors">
              Events
            </a>
            <a href="/contact" className="block text-kala-secondary text-sm hover:text-kala-blue transition-colors">
              Contact Us
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-kala-border my-8"></div>

        {/* Copyright */}
        <div className="text-center text-kala-secondary text-sm">
          <p>&copy; 2025 KALARAVA. All rights reserved.</p>
          <p className="mt-2">KLE Society's College of BBA and BCA | 29 November 2025</p>
        </div>
      </div>
    </footer>
  )
}
